import React, { useEffect, useState } from "react";
import { gql, useLazyQuery } from "@apollo/client";
import { Skeleton, Drawer } from "antd";
import OtherErrors from "@general/otherErrors";
import moment from "moment-jalaali";
import AdminUsersListTable from "./table";
import UserControl from "./userControl";
import TableFilters from "@general/tableFilters";
import getWindowSize from "@utils/windowSize";
import { useSearchParams } from "react-router-dom";

const GETUSERS = gql`
  query ($paginateInput: PaginateInput!, $searchInput: UserSearchInput!) {
    getUsersCount(searchInput: $searchInput)
    totalUsersCount: getUsersCount(searchInput: { userRole: [USER] })
    getUsers(paginateInput: $paginateInput, searchInput: $searchInput) {
      id
      name
      nationalIdCardNo
      mobile
      createdAt
      deactivatedAt
      confirmStatus
      userRole
    }
  }
`;

function AdminUsers(props) {
  const [tableData, setTableData] = useState({});
  const [currentPage, setCurrentPage] = useState();
  const [sortDir, setSortDir] = useState("desc");
  const [sortColumn, setSortColumn] = useState("createdAt");
  const [filterDateFrom, setFilterDateFrom] = useState(null);
  const [filterDateTo, setFilterDateTo] = useState(null);
  const [filterSearchPhrase, setFilterSearchPhrase] = useState("");
  const [drawer, setDrawer] = useState(false);

  const windowSize = getWindowSize().innerWidth;

  const [getUsers, users] = useLazyQuery(GETUSERS, {
    fetchPolicy: "no-cache",
    onCompleted(data) {
      setTableData(data);
    },
  });
  const [searchParams, setSearchParams] = useSearchParams();
  const filteredConfirmStatus = searchParams.get("confirmStatus");
  useEffect(() => {
    getUsers({
      variables: {
        paginateInput: {
          page: currentPage,
          perPage: 10,
          sort: sortColumn && sortColumn,
          sortDir: sortDir,
        },
        searchInput: {
          createdAt:
            filterDateFrom && filterDateTo
              ? [filterDateFrom, filterDateTo]
              : null,
          textSearch: filterSearchPhrase,
          confirmStatus: filteredConfirmStatus,
        },
      },
    });
  }, [currentPage, sortDir, filterDateTo, filterSearchPhrase]);

  const userDataUpdated = () => {
    getUsers({
      variables: {
        paginateInput: {
          page: currentPage,
          perPage: 10,
          sort: sortColumn && sortColumn,
          sortDir: sortDir,
        },
        searchInput: {},
      },
    });
  };

  const pageChange = (current) => {
    setCurrentPage(current);
  };

  const sort = (sortData) => {
    setCurrentPage(1);
    setSortColumn(sortData.columnKey);
    if (sortData.order === "ascend") setSortDir("asc");
    if (!sortData.order || sortData.order === "descend") setSortDir("desc");
  };

  const filterDate = (dates, dateString) => {
    setCurrentPage(1);
    if (dateString[0] === "" || dateString[1] === "") {
      setFilterDateFrom(null);
      setFilterDateTo(null);
    } else {
      setFilterDateFrom(
        moment(dateString[0], "jYYYY/jMM/jDD")
          .startOf("day")
          .toDate()
          .toISOString()
      );
      setFilterDateTo(
        moment(dateString[1], "jYYYY/jMM/jDD")
          .endOf("day")
          .toDate()
          .toISOString()
      );
    }
  };

  const filterSearch = (phrase) => {
    setCurrentPage(1);
    setFilterSearchPhrase(phrase);
  };

  const openDrawer = (id, name) => {
    setDrawer({ id, name });
  };
  const closeDrawer = () => {
    setDrawer(false);
  };

  if (users.error) return <OtherErrors />;
  if (Object.keys(tableData).length === 0)
    return (
      <>
        <Skeleton active round />
        <br />
        <Skeleton active round />
      </>
    );
  return (
    <>
      <Drawer
        title="مدیریت کاربر"
        placement="right"
        open={drawer}
        onClose={closeDrawer}
        size={windowSize >= 750 ? "large" : null}
        width={windowSize < 750 ? windowSize - 50 : null}
      >
        <UserControl
          id={drawer.id}
          onUserDataUpdate={userDataUpdated}
          onCloseDrawer={closeDrawer}
        />
      </Drawer>
      <TableFilters
        onFilterDate={filterDate}
        onFilterSearch={filterSearch}
        hint={"بر اساس تاریخ ثبت نام"}
      />

      <AdminUsersListTable
        onUserDataUpdate={userDataUpdated}
        data={tableData}
        onSort={sort}
        onPageChange={pageChange}
        currentPage={currentPage}
        loading={users.loading}
        onOpenDrawer={openDrawer}
      />
    </>
  );
}

export default AdminUsers;
